prepDrawers = () => {

  const drawers = document.querySelectorAll(".drawer:not(.bound):not(.stop-click)");

  console.log(drawers);

  for (let i = 0; i < drawers.length; i++) {

    const thisDrawer = drawers[i];
    thisDrawer.classList.add("bound");
    const childrenWrapper = thisDrawer.querySelector(".drawer-items");

    if (!childrenWrapper) {
      continue;
    }
    // const childrenWrapperHeight = childrenWrapper.offsetHeight;
    childrenWrapper.addEventListener("click", (event) => {
      event.stopPropagation();
    });

    thisDrawer.addEventListener("click", (event) => {

      if (!thisDrawer.classList.contains("open")) {

        const openDrawers = document.querySelectorAll(".drawer.open");
        for (let i = 0; i < openDrawers.length; i++) {
          openDrawers[i].classList.remove("open");
          gsap.to(openDrawers[i].querySelector(".drawer-items"), 0.5, { height: 0, force3D: true, ease: Sine.easeInOut });
          gsap.to(openDrawers[i].querySelectorAll(".drawer-items"), 0.35, { autoAlpha: 0, force3D: true, ease: Sine.easeInOut });
        }
        thisDrawer.classList.add("open");
        // if (globalStorage.ww < 768) {
        // 	gsap.to(domStorage.mainEl, 0.4, { scrollTop: origOffsetTop, ease: Sine.easeOut })
        // }
        // gsap.to(childrenWrapper, 0.5, {
        //   height: childrenWrapperHeight, force3D: true, ease: Sine.easeInOut, onComplete: () => {
        //     if ($scroll) {
        //       $scroll.resize();
        //     }
        //   }
        // });

         gsap.to(childrenWrapper, 0.5, {
    height: "auto", // Use "auto" instead of a fixed height
    force3D: true, 
    ease: Sine.easeInOut, 
    onComplete: () => {
      if ($scroll) {
        $scroll.resize();
      }
    }
  });


  
        gsap.fromTo(childrenWrapper, 0.7, { autoAlpha: 0.2 }, { opacity: 1, force3D: true, ease: Sine.easeInOut });
      } else {
        thisDrawer.classList.remove("open");
        gsap.to(childrenWrapper, 0.35, {
          height: 0, force3D: true, ease: Sine.easeInOut, onComplete: () => {
            if ($scroll) {
              $scroll.resize();
            }
          }
        });
        gsap.to(childrenWrapper, 0.35, { autoAlpha: 0, force3D: true, ease: Sine.easeInOut });
      }
    });
    gsap.set(childrenWrapper, { height: 0, autoAlpha: 0 });
    let origOffsetTop = thisDrawer.getBoundingClientRect().top - 120;
    if ((i === drawers.length - 1) && $scroll) {
      $scroll.resize();
    }

    if (thisDrawer.classList.contains("default-open")) {
      thisDrawer.click();
    }
  }
};